import { onDomReady } from '~/javascripts/dom_ready'
document.addEventListener('turbo:load', () => {
  $("#add_feature_button").unbind("click");
  $('a.accordion-toggle').unbind("click");
  $(document).ready(function() {
    activate_vin_lookup();
    activate_body_type_lookup();
    $('.applyBtn').on('click', function() {
      var dateRange = $('#dateRangeInput').val();
      var selectedNavValued =  $('.nav-link.selected').attr('data-value') || 'd';
      var dateArray = dateRange.split(' - ');
      var startDate = dateArray[0];
      var endDate = dateArray[1];
      var url = '/overview?start_date=' + startDate + '&end_date=' + endDate + '&nav_stat=' + selectedNavValued;
      Turbo.visit(url, { action: 'replace', frame: "overview-frame" });
    });
    var startDate, endDate;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const startDateParam = urlSearchParams.get("start_date");
    const endDateParam = urlSearchParams.get("end_date");
    if (startDateParam && endDateParam){
      $('#dateRangeInput').val(startDateParam + ' - ' + endDateParam);
      // ★★ This threw "Cannot read properties of undefined (reading 'getElementsByClassName')"
      // for 6 dealers / 23 times in the week to 2026-10-06 (PostHog $exception, /reports/*).
      //
      // It indexes [1] — the SECOND `.choices__list--single` on the page. Pages that render only
      // one (or none) gave `undefined`, and the next line dereferenced it. The throw happens
      // inside this `$(document).ready` block, so it ABORTED THE REMAINING ~168 LINES of the
      // handler: the #dailySelect date presets (week/mon/21d/mtd/qtd/ytd), the hidden-input
      // injection, and the "Please select at least one option (Yes or No)" form validation, which
      // simply stopped running. Only reachable with start_date+end_date in the URL, which is why
      // it showed up on reports and overview rather than everywhere.
      var parentElement = document.getElementsByClassName('choices__list--single')[1];
      var elementToHide = parentElement &&
        parentElement.getElementsByClassName('choices__item--selectable')[0];
      if (elementToHide) {
        elementToHide.style.display = 'none';
      }
      endDate = new Date(endDateParam)
      startDate = new Date(startDateParam)
      startDate = formatDate(startDate);
      endDate = formatDate(endDate);
      $('#dateRangeInput').val(startDate + ' - ' + endDate);
    }
    if ($('#dailySelect').val() === 'week') {
      if (!startDateParam){
        endDate = new Date();
        startDate = new Date();
        startDate.setDate(startDate.getDate() - 6);
        startDate = formatDate(startDate);
        endDate = formatDate(endDate);
        $('#dateRangeInput').val(startDate + ' - ' + endDate);
      }
    }
    else if($('#dailySelect').val() === 'mon'){
      endDate = new Date();
      startDate = new Date();
      startDate.setDate(startDate.getDate() - 29);
      startDate = formatDate(startDate);
      endDate = formatDate(endDate);
      $('#dateRangeInput').val(startDate + ' - ' + endDate);
    }
    else if ($('#dailySelect').val() === '21d'){
      endDate = new Date();
      startDate = new Date();
      startDate.setDate(startDate.getDate() - 21);
      startDate = formatDate(startDate);
      endDate = formatDate(endDate);
      $('#dateRangeInput').val(startDate + ' - ' + endDate);
    }
    else if($('#dailySelect').val() === 'mtd'){
      endDate = new Date();
      startDate = new Date();
      startDate.setDate(1);
      startDate = formatDate(startDate);
      endDate = formatDate(endDate);
      $('#dateRangeInput').val(startDate + ' - ' + endDate);
    }
    else if($('#dailySelect').val() === 'qtd'){
      endDate = new Date();
      startDate = getStartOfQuarter(new Date());
      startDate = formatDate(startDate);
      endDate = formatDate(endDate);
      $('#dateRangeInput').val(startDate + ' - ' + endDate);
    }
    else if($('#dailySelect').val() === 'ytd'){
      endDate = new Date();
      var startDate = getStartOfYear(new Date());
      startDate = formatDate(startDate);
      endDate = formatDate(endDate);
      $('#dateRangeInput').val(startDate + ' - ' + endDate);
    }
    var selectedNavValued =  $('.nav-link.selected').attr('data-value') || 'd';
    $('#dailySelect').on('change', function() {
      selectedSelectValue = $(this).val();
      var url = '/overview?graph_stat=' + selectedSelectValue + '&nav_stat=' + selectedNavValued;
      Turbo.visit(url, { action: 'replace', frame: "overview-frame" });
    });
    $('.nav-link.active').data('value', selectedSelectValue);

    var selectedSelectValue = $('#dailySelect').val();
    var selectedNavValue = "d";
    $('.nav-link[data-value="' + selectedNavValue + '"]').addClass('active'); // Add 'active' class to the default nav link

    $('.navLink').on('click', function(e) {
      e.preventDefault();
      $('.nav-link').removeClass('active'); // Remove 'active' class from all nav links
      $(this).addClass('active'); // Add 'active' class to the clicked nav link
      selectedNavValue = $(this).data('value');
      const urlSearchParams = new URLSearchParams(window.location.search);
      const startDateParam = urlSearchParams.get("start_date");
      const endDateParam = urlSearchParams.get("end_date");
      if (startDateParam && endDateParam){
        $('#dateRangeInput').val(startDateParam + ' - ' + endDateParam);
        var url = '/overview?start_date=' + startDateParam + '&end_date=' + endDateParam + '&nav_stat=' + selectedNavValue;
      }
      else {
        var url = '/overview?graph_stat=' + selectedSelectValue + '&nav_stat=' + selectedNavValue;
      }
      Turbo.visit(url, { action: 'replace', frame: "overview-frame" });
    });

    // NOTE: the period dropdown (#dailySelect) is a Choices-backed <select> whose
    // value is rendered server-side from @graph_stat (and re-rendered on every
    // overview-frame Turbo replace), so it is already in sync with the current
    // period. A previous line here did `$('#dailySelect').val(selectedNavValue)`,
    // which is wrong twice over: `selectedNavValue` is a NAV value ("d"), not one
    // of the period options (week/21d/mon/mtd/qtd/ytd), and a bare jQuery `.val()`
    // on a Choices select desyncs the widget from the native <select>. Removed —
    // the server-rendered `selected: @graph_stat` is the source of truth.

    $('#collapse-feature').css('display', 'block');

    $('.clear_features').on('click', function (event) {
      var section, name, $el;

      event.preventDefault();

      section = $(this).data('feature-section');
      name = 'inventory[features][' + section + '][]';
      $el = $('#' + section + '_features');
      $el.empty();
      if ($('input[name="' + name + '"]').length === 0) $el.after('<input type="hidden" name="' + name + '">');
      sync_clear_feature_links();
    });

    const form = document.querySelector('form');
    const yesCheckbox = document.getElementById('header_row_yes');
    const noCheckbox = document.getElementById('header_row_no');

    // These checkboxes only exist on the CSV-import page; without this guard the
    // handler threw on every other page's form submit (including login).
    if (form && yesCheckbox && noCheckbox) {
      form.addEventListener('submit', function(event) {
        if (!yesCheckbox.checked && !noCheckbox.checked) {
          alert('Please select at least one option (Yes or No).');
          event.preventDefault();
        }
      });
    }
    var forms = document.querySelectorAll('.inner-form-vendor');
    forms.forEach(function(form) {
        form.style.display = 'none'; // Hide all forms initially
    });

    // ★ The per-link click binding that used to live here is GONE, and deliberately.
    //
    // It captured `index` from the link list at BIND time but re-queried
    // `.inner-form-vendor` at CLICK time, so as soon as the two lists differed in length —
    // routine on inventory_costs, where cost rows are added and removed dynamically —
    // `forms[index]` was undefined and `formToShow.style` threw. PostHog caught it as
    // "TypeError: Cannot read properties of undefined (reading 'style')" in
    // HTMLAnchorElement.<anonymous> on /inventory/:slug/inventory_costs.
    //
    // Worse than the crash: a DELEGATED `.add-vendor` handler further down this file already
    // does the same toggle, correctly and for dynamically-added rows too. Both fired on every
    // click, so the panel toggled twice and settled back where it started — the link looked
    // dead even when nothing threw. That is what dealers were clicking at.
    //
    // The initial hide above is kept; the delegated handler owns the toggling from here.

    const checkboxes = document.querySelectorAll('.form-check-input');

    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        if (this.checked) {
          // Uncheck the other checkbox
          if (this.id === 'header_row_yes') {
            noCheckbox.checked = false;
          } else if (this.id === 'header_row_no') {
            yesCheckbox.checked = false;
          }
        }
      });
    });
    $('#remind-at').hide();
    $('#reminder-checkbox').change(function() {
      if ($(this).is(':checked')) {
        $('#remind-at').show();
      } else {
        $('#remind-at').hide();
      }
    });
  });
  $('a.accordion-toggle').on('click', function(e) {
    e.preventDefault();
    $('#collapse-feature').toggle();
  });

  $('#custom_link_field').hide();

  $('#add_custom_link').click(function(event){
    event.preventDefault();
    $('#custom_link_field').show();
    $('#add_custom_link').hide();
  });

  var accordionToggles = document.querySelectorAll('.accordion-toggle');

  accordionToggles.forEach(function (toggle) {
  toggle.addEventListener('click', function (event) {
    event.preventDefault();

    var accordionBodyId = this.getAttribute('href').substring(1);
    var accordionBody = document.getElementById(accordionBodyId);

    // Toggle the 'hidden' class to show/hide the accordion body
    if (accordionBody.style.display === 'none' || accordionBody.style.display === '') {
      accordionBody.style.display = 'block';
    } else {
      accordionBody.style.display = 'none';
    }
    });
  });
  $("input#add_feature").keypress(function(e){
    // 13 = enter key
    if (e.which == 13) { e.preventDefault(); add_feature_via_form() }
  });
  $("#add_feature_button").click(function(e){
    e.preventDefault();
    add_feature_via_form();
    $("#add_feature").focus();
  });
  function add_feature_via_form(){
    var feature_field = $("#add_feature");
    var value = $("#add_feature").val();
    feature_field.val("");
    add_feature_to_inventory(value, "standard")
  }
  // ★ The default LENGTH used to be `Math.floor(Math.random() * chars.length)`, which can come out
  // 0 — the chip's id was then the bare string "item_", and every other zero-length draw produced
  // the SAME id. That is not theoretical: 26 of the 543 remove-feature clicks PostHog recorded in
  // the last fortnight were on a chip whose id was exactly "item_" (another 19 had 1- or 2-char
  // ids). Colliding ids matter because update_feature_details() reaches the chip's hidden field by
  // id when a chip is dragged between Standard and Optional, and jQuery's `#id` goes through
  // querySelectorAll — which returns EVERY element carrying that id, so the rename landed on
  // features the dealer never dragged and they silently changed section. A fixed length plus a
  // per-page counter is unique by construction. Nothing parses the id's shape.
  var feature_id_seq = 0;
  function random_string(length) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split('');
    if (! length) {
        length = 12;
    }
    var str = '';
    for (var i = 0; i < length; i++) {
        str += chars[Math.floor(Math.random() * chars.length)];
    }
    return "item_" + str;
  }

  function next_feature_id() {
    feature_id_seq += 1;
    return random_string() + "_" + feature_id_seq;
  }

  // The feature name is interpolated into an attribute value AND into the chip's text, so it has to
  // be escaped for both. It used to go in raw: a dealer typing "Driver's Air Bag" into Add Feature
  // closed the single-quoted value= at the apostrophe, the rest became stray attributes, and the
  // record saved "Driver". A name with no special characters escapes to itself, so what already
  // works keeps saving byte-for-byte the same value.
  function escape_html(value) {
    return String(value === null || value === undefined ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  function formatDate(date) {
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;

    return month + '/' + day + '/' + year;
  }
  function getStartOfQuarter(date) {
    const quarterStartMonth = Math.floor(date.getMonth() / 3) * 3;
    return new Date(date.getFullYear(), quarterStartMonth, 1);
  }
  function getStartOfYear(date) {
    return new Date(date.getFullYear(), 0, 1);
  }
  function add_feature_to_inventory(value, type){
    var id = next_feature_id();
    var safe_value = escape_html(value);
    // The input carries its OWN id (suffixed), not the chip div's — the two used to be identical,
    // which is invalid HTML and is why `input#<id>` in update_feature_details only ever worked by
    // accident. Matches inventory/_features_dropzone for the server-rendered chips.
    var new_feature_input = "<input id='" + id + "_value' " +
      "name='inventory[features][" + type + "][]' type='hidden' " +
      "value='" + safe_value + "'></div>";
    var new_feature_el = "<div style='margin: 5px' class='feature' id='" + id + "'>" +
                  safe_value +
                  ' <a href="" class="fa fa-remove remove_feature"><i class="icon-remove"></i></a>'.
                  concat(new_feature_input);
    var add_to = type == "standard" ? "#standard_features" : "#optional_features";
    $(add_to + ".dropzone").append(new_feature_el);
    sync_clear_feature_links();
  }

  // The "Clear all standard/optional features" links are always in the DOM (inventory/v2/_tab_features)
  // and shown only while their list has chips. They used to be rendered only when the vehicle HAD
  // features at page load — so on /inventory/new, where a VIN decode fills the lists from here, there
  // was no way to clear 30 decoded features except one .remove_feature click each (PostHog 2026-10-20:
  // five rage-click bursts from one dealer in 12 minutes). Called after every add, remove, clear, drag
  // between sections, and decode.
  function sync_clear_feature_links() {
    ['standard', 'optional'].forEach(function (section) {
      var count = $('#' + section + '_features.dropzone .feature').length;
      $('.clear_features[data-feature-section="' + section + '"]').css('display', count ? 'inline-block' : 'none');
    });
  }

  $(function(){
    $("#window_sticker_id").change(function () {
      var sticker_id = $(this).find("option:selected").attr('value');
      var path = "print_window_sticker";
      if (sticker_id) window.open(path + "/" + sticker_id + ".pdf", "_blank");
    })
  });

  $(function(){
    $("#export_vehicle_html_id").change(function () {
      var template_id = $(this).find("option:selected").attr('value');
      var path = "export_item_html";
      if (template_id) window.open(path + "?template=" + template_id, "_blank");
    })
  });
  
  $(function(){
    $("#export_vehicle_img_id").change(function () {
      var template_id = $(this).find("option:selected").attr('value');
      var path = "export_item_img";
      if (template_id) window.open(path + "?template=" + template_id, "_blank");
    })
  });

  $("#third_party_exports").hide();
  $(document).on("click", "#show-exports-link", function(e) {
    e.preventDefault();

    var thirdPartyExports = $("#third_party_exports");

    if (thirdPartyExports.is(":visible")) {
      thirdPartyExports.hide();
      $("#show-exports-link").text("Show exports");
    } else {
      thirdPartyExports.show();
      $("#show-exports-link").text("Hide exports");
    }
  });
  $(document).ready(function(){
    $(".update-checkmark").hide();
    $(".update-button-partner").click(function(){
      $(".update-checkmark").toggle();
    });
  });

  $('body').on("click", ".remove_feature", function (event) {
    var $feature, $features, section;

    event.preventDefault();

    $feature = $(event.target).closest(".feature");
    $features = $feature.parent();
    section = $features.attr('id').replace('_features', '');

    $feature.remove();
    if ($features.children().length === 0) $features.html('<input type="hidden" name="inventory[features][' + section + '][]">');
    sync_clear_feature_links();
  });
  // ★jQuery UI sortable swallows the click on the remove "X". Its `cancel` option defaults to
  // "input,textarea,button,select,option" — an <a class="remove_feature"> is not in that list, so
  // mousedown on the X STARTS A DRAG, and with `distance` defaulting to 1px a single pixel of
  // movement on a ~10px icon means the click never fires and the chip is not removed. The dealer
  // clicks again, and again: 39 rage-clicks from 4 dealers on this one element in a fortnight,
  // second only to the VIN field. Listing the defaults explicitly because setting `cancel` REPLACES
  // them rather than adding to them.
  var FEATURE_DRAG_CANCEL = 'input,textarea,button,select,option,a,.remove_feature';

  $("#optional_features.dropzone").sortable({
    items: '.feature',
    cancel: FEATURE_DRAG_CANCEL,
    connectWith: '#standard_features.dropzone',
    containment: '.features_section',
    receive: function(event, ui){
      var new_id = $(ui.item).attr("id");
      if ($(ui.sender).attr("id") == "common_features"){
        add_feature_to_inventory($(ui.item).text().trim(), "optional");
        $("#" + new_id).remove();
      } else {
        update_feature_details(new_id, 'optional');
      }
      sync_clear_feature_links();
    }
  });

  $("#standard_features.dropzone").sortable({
    items: '.feature',
    cancel: FEATURE_DRAG_CANCEL,
    connectWith: '#optional_features.dropzone',
    containment: '.features_section',
    receive: function(event, ui){
      var new_id = $(ui.item).attr("id");
      if ($(ui.sender).attr("id") == "common_features"){
        add_feature_to_inventory($(ui.item).text().trim(), "standard");
        $("#" + new_id).remove();
      } else {
        update_feature_details(new_id, 'standard');
      }
      sync_clear_feature_links();
    }
  });

  function update_feature_details(el, section){
    var old_section = section == "standard" ? "optional" : "standard";
    // Reach the chip's own hidden field THROUGH the chip. `input#<el>` relied on the input sharing
    // the div's id, so any id collision renamed some other chip's field (see next_feature_id).
    var item = $("#" + el).find("input[type=hidden]");
    var name = item.attr("name");
    if (!name) return;

    var new_section = name.replace(old_section, section);
    item.attr("name", new_section);
  }

  $("#common_features").sortable({
    items: '.feature',
    cancel: FEATURE_DRAG_CANCEL,
    connectWith: "#optional_features.dropzone, #standard_features.dropzone"
  });

  $(function () {
    function adjustBuyersGuideWarranty() {
      var warrantyCheckbox = $('#buyers_yes'); // Change to the appropriate checkbox ID

      if (warrantyCheckbox.prop('checked')) {
        $('.buyers-guide-warranty').show();
      } else {
        $('.buyers-guide-warranty').hide();
      }
    }
    adjustBuyersGuideWarranty();

    $('input[name="buyers_guide[warranty]"]').change(function() {
      $('input[name="buyers_guide[warranty]"]').not(this).prop('checked', false);
      adjustBuyersGuideWarranty();
    });
    $('input[name="buyers_guide[full_warranty]"]').change(function() {
      $('input[name="buyers_guide[full_warranty]"]').not(this).prop('checked', false);
    });
    $('input[name="buyers_guide[service_contract]"]').change(function() {
      $('input[name="buyers_guide[service_contract]"]').not(this).prop('checked', false);
    });
    $('input[name="buyers_guide[english]"]').change(function() {
      $('input[name="buyers_guide[english]"]').not(this).prop('checked', false);
    });
  });

  $(document).ready(function() {
    $("#post-to-facebook").on("click", function(event) {
      event.preventDefault();
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent($(this).data("url")), "Post to Facebook", "width=640, height=480");
      var vehicleId = $(this).attr('data-vehicle');
      $.ajax({
        url: '/inventory/' + vehicleId + '/export_log_record',
        type: 'POST',
        data: {
          location: "Facebook"
        },
      });
    });
  });

  $(function(){
    $(".buyers_guide_select").change(function () {
      var url = $(this).find("option:selected").val()
      if (url) window.open(url, "_blank");
    })
  });

  function initializePage() {
      const sortDropdown = document.getElementById('sort-dropdown');
      // The active-inventory page now drives sort/filter via the Vue menu, so
      // this legacy dropdown may be absent — bail out cleanly when it is.
      if (!sortDropdown) return;

      const updateResults = () => {
        const redirectUrl = `/api/inventory/filter_sort?sort=${sortDropdown.value}`;
        window.location.href = redirectUrl;
      };

      sortDropdown.addEventListener('change', updateResults);
      const filterDropdown = document.getElementById('filter-dropdown');
      if (filterDropdown) filterDropdown.addEventListener('change', updateResults);
    }
  initializePage();

  onDomReady(function () {
    initializePage();
  });
  onDomReady(function() {
      // Add an event listener to the select element
    const importSection = document.getElementById("import_section");
    // Only present on the import settings page — bail out elsewhere.
    if (!importSection) return;
    importSection.addEventListener("change", function() {
      const selectedValue = importSection.value;
      // Hide both options by default
      document.getElementById("cars_for_sale_options").style.display = "none";
      document.getElementById("autotrader_options").style.display = "none";

      // Show the corresponding option based on the selected value
      if (selectedValue === "CarsForSale") {
        document.getElementById("cars_for_sale_options").style.display = "block";
      } else if (selectedValue === "AutoTrader") {
        document.getElementById("autotrader_options").style.display = "block";
      }
    });
  });
  function toggleDropdown(dropdownToggle, dropdownMenu) {
    dropdownToggle.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      closeAllDropdowns();

      dropdownMenu.classList.toggle("show");
    });
  }

  function closeAllDropdowns() {
    var openDropdowns = document.querySelectorAll(".dropdown-menu.show");
    openDropdowns.forEach(function (openDropdown) {
      openDropdown.classList.remove("show");
    });
  }

  var shareDropdownToggle = document.querySelector("#shareDropdownToggle");
  var shareDropdownMenu = document.querySelector("#shareDropdownToggle + .dropdown-menu");

  var manageDropdownToggle = document.querySelector("#manageDropdownToggle");
  var manageDropdownMenu = document.querySelector("#manageDropdownToggle + .dropdown-menu");

  if (shareDropdownToggle) {
    toggleDropdown(shareDropdownToggle, shareDropdownMenu);
  }

  if (manageDropdownToggle) {
    toggleDropdown(manageDropdownToggle, manageDropdownMenu);
  }

  document.addEventListener("click", function (event) {
    closeAllDropdowns();
  });
  $("form a.add_child").off("click").on("click", function() {
    var targ = $(this);
    targ.addClass("disabled");
    var assoc = targ.attr("data-association");
    var content = $("#" + assoc + "_fields_template").html();
    var regexp = new RegExp("new_" + assoc, "g");
    var new_id = new Date().getTime();
    var $content = $(content.replace(regexp, new_id));

    // Append the new fields to the #fields div
    $("#fields").append($content);

    // Reinitialize any needed plugins or add functionality
    $content.find("select.formula_picker").on("change", function() {
        var selectedValue = $(this).val();
        if (selectedValue === "") {
          var customInput = prompt("Please enter a custom formula:");
          if (customInput) {
              // Add the custom input value to the select
              $(this).append(new Option(customInput, customInput, true, true));
              $(this).val(customInput); // Set the value to the custom input
          }
        }
    });

    // Add a one-second delay before re-enabling the link to ensure proper ordering
    setTimeout(function() {
        targ.removeClass("disabled");
    }, 1000);

    return false; // Prevent the default action of the link
  });

  var errorCount = 0;   // Track consecutive errors
  function activate_vin_lookup() {
    var currentVin = ''; // Track the last VIN we looked up
    var VIN_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/i; // Frontend VIN validation (matches BE)

    // Handle VIN input changes
    $("#inventory_vin").on('input', function(e) {
        var inventoryVin = $(this).val().replace(/\s/g, ''); // Remove all whitespace
        $(this).val(inventoryVin); // Update the field with cleaned value
        $(".first_notice").hide();

        // Only proceed if we have exactly 17 characters and it's a new VIN
        if (inventoryVin.length === 17 && inventoryVin !== currentVin) {
            start_lookup();
        }
    });

    // Manual trigger button
    $(".vin_lookup_trigger").click(function(e) {
        e.preventDefault();
        $(".first_notice").hide();
        start_lookup();
    });

    function start_lookup() {
        var vin = $("#inventory_vin").val().trim();
        
        // Basic validation
        if (!vin || vin === "Add a VIN") {
            vin_load_notice("Please supply a VIN", 2000);
            return false;
        }

        // Length validation
        if (vin.length !== 17) {
            vin_load_notice("Please enter a 17-digit VIN to decode", 2000);
            return false;
        }

        // Format validation (matches backend regex)
        if (!VIN_REGEX.test(vin)) {
            vin_load_notice("Invalid VIN format", 5000);
            return false;
        }

        // Show loading state
        $("#decoding").show();
        $(".vin_lookup_trigger").hide();
        $(".vin_decoded").hide();
        $(".spinner").show();

        // Store the current VIN to prevent duplicate requests
        currentVin = vin;

        $.ajax({
            url: "/inventory/" + vin + "/vin_lookup.json",
            dataType: "json",
            success: function(data) {
                // Reset error count on success
                errorCount = 0;
                
                $(".vin_decoded").show();
                populate_vin_data(data.inventory);
            },
            error: function() {
                errorCount++;
                
                // Different messages based on error count
                if (errorCount >= 2) {
                    vin_load_notice("Having trouble decoding? Please verify the VIN", 10000);
                } else {
                    vin_load_notice("VIN is invalid, please try again", 2000);
                }
                
                // Clear the current VIN so we can retry
                currentVin = '';
            },
            complete: function() {
                // Hide loading indicators
                $("#decoding").hide();
                $(".vin_lookup_trigger").show();
                $(".spinner").hide();
            }
        });
    }

    // A decode must FILL BLANKS, never clobber the dealer.
    //
    // This used to overwrite year/make/model, trim, engine, stock number and — worst — DELETE the
    // entire features list and replace it, every single time it ran. On a NEW vehicle that is
    // exactly what you want. On an EDIT it silently destroys work: a dealer who corrected the trim,
    // fixed the engine, or curated the feature list lost all of it the moment a VIN was re-decoded,
    // with no warning and nothing to undo.
    //
    // It matters more now than it did: the decode fires automatically as soon as the field holds 17
    // characters, and select-on-entry (added the same day) turned replacing a VIN into one click and
    // a paste. The easier that got, the more reachable this became.
    //
    // The rule: a field is the decoder's to write only while it is EMPTY or still holds what a
    // previous decode put there. The moment a human edits it, it is theirs and the decoder leaves it
    // alone. That keeps the new-vehicle flow intact — decode, notice a typo, re-decode, everything
    // still updates — while making it impossible to lose typed work on an existing vehicle.
    // "Still the decoder's" is decided by COMPARING VALUES, not by listening for edits. An event
    // hook would be wrong here: set_select_value drives Choices.js, which fires `change` on the
    // underlying select, so a "human touched it" listener would clear the flag the instant the
    // decode set it — and the body_type write is asynchronous, so no setTimeout guard covers it
    // reliably either. Storing what was written and checking the field still holds it has no timing
    // question in it at all.
    var VIN_FILLED = "data-vin-filled";

    function vin_may_write($el) {
        if (!$el.length) return false;
        var current = $.trim($el.val() || "");
        if (current === "") return true;                       // blank: fill it
        return $el.attr(VIN_FILLED) === current;               // unchanged since the decode wrote it
    }

    function vin_write($el, value) {
        if (!vin_may_write($el)) return;
        $el.val(value).removeClass("inactive");
        $el.attr(VIN_FILLED, $.trim($el.val() || ""));
    }

    function vin_write_select($el, value) {
        if (!vin_may_write($el)) return;
        set_select_value($el, value);
        $el.attr(VIN_FILLED, $.trim($el.val() || ""));
    }

    // Features are DOM chips rather than one input, so the same question is asked of the set: it is
    // the decoder's only while it still holds exactly what the last decode put there.
    function features_signature() {
        return $("#standard_features.dropzone .feature, #optional_features .feature")
                 .map(function () { return $.trim($(this).text()); }).get().sort().join("|");
    }

    function features_may_write() {
        var sig = features_signature();
        if (sig === "") return true;
        return $("#standard_features").attr(VIN_FILLED) === sig;
    }

    function populate_vin_data(vinData) {
        var fields = [
            'year', 'make', 'model', 'trim_level', 'engine', 
            'body_type', 'vehicle_type', 'doors', 'transmission',
            'features', 'fuel_economy_city', 'fuel_economy_highway', 
            'stock_number'
        ];
        var skipped = [];

        fields.forEach(function(field) {
            if (!vinData[field]) return;

            if (field === 'features') {
                if (!features_may_write()) { skipped.push("features"); return; }
                $("#standard_features.dropzone .feature, #optional_features .feature").remove();

                (vinData.features.optional || []).forEach(function(feature) {
                    add_feature_to_inventory(feature, "optional");
                });
                (vinData.features.standard || []).forEach(function(feature) {
                    add_feature_to_inventory(feature, "standard");
                });
                $("#standard_features").attr(VIN_FILLED, features_signature());
                sync_clear_feature_links();
            } 
            else if (field === 'vehicle_type') {
                var $vt = $("#inventory_vehicle_type");
                if (!vin_may_write($vt)) { skipped.push("vehicle type"); return; }
                vin_write_select($vt, vinData.vehicle_type);

                // Special handling for body type that depends on vehicle type
                load_body_type_lookup(
                    $("#inventory_vehicle_type"),
                    $(".body_type"),
                    function() {
                        vin_write_select($(".body_type"), vinData.body_type);
                    }
                );
            }
            else if (field === 'doors' || field === 'transmission') {
                // These are Choices.js <select>s on the legacy form; a plain .val()
                // updates the hidden native select but not the visible widget.
                var $sel = $("#inventory_" + field);
                if (!vin_may_write($sel)) { skipped.push(field.replace("_", " ")); return; }
                vin_write_select($sel, vinData[field]);
            }
            else {
                var $f = $("#inventory_" + field);
                if (!vin_may_write($f)) { skipped.push(field.replace("_", " ")); return; }
                vin_write($f, vinData[field]);
            }
        });

        // Say what was left alone, so a dealer who expected the decode to refresh a field knows why
        // it did not — silence here would just move the confusion rather than remove it.
        if (skipped.length) {
            vin_load_notice("Decoded. Kept your own " + skipped.join(", ") + ".", 6000);
        }
    }

    function vin_load_notice(message, delay) {
      $(".load_notice").html(message).show().delay(delay).fadeOut(2000);
    }
  }

  function activate_body_type_lookup() {
    // The v2 specs-tab vehicle-type select carries BOTH id="inventory_vehicle_type"
    // and class="vehicle_type"; bind once (by class) so we don't fire the lookup
    // twice. Preserve the current body_type so editing an existing vehicle keeps
    // its selected value when the option list is reloaded.
    // DELEGATED (not a direct bind) so trade-in rows added AFTER page load via
    // add_child also cascade — a direct $('select.vehicle_type').on(...) only wired up
    // the rows present at turbo:load, so a freshly-added trade-in's body_type dropdown
    // stayed empty (only the blank option) and the pick saved blank. SCOPED to the row
    // (.inventory_fields) so changing one vehicle's type reloads only ITS body_type,
    // not every body_type select on a multi-trade-in deal.
    $(document).off('change.bodyTypeLookup', 'select.vehicle_type')
      .on('change.bodyTypeLookup', 'select.vehicle_type', function () {
        var $scope = $(this).closest('.inventory_fields');
        var $bodyType = ($scope.length ? $scope : $(document)).find('select.body_type').first();
        if ($bodyType.length === 0) return;
        var current = $bodyType.val();
        load_body_type_lookup($(this), $bodyType, function () {
          if (current) set_select_value($bodyType, current);
        });
      });
  }

  function load_body_type_lookup($vehicleTypeSelect, $bodyTypeSelect, callback) {
    var vehicleType = $vehicleTypeSelect.val();
    $.get('/inventory/body_type_lookup?vehicle_type=' + vehicleType, function (data) {
      var bodyEl = $bodyTypeSelect.get(0);
      var choices = bodyEl && bodyEl._choices;
      if (choices) {
        // Rebuild the options through the Choices instance so the visible widget
        // reflects the new list (manipulating the hidden native <option>s does not).
        var newChoices = [{ value: '', label: '' }].concat(
          $.map(data, function (value) { return { value: value, label: value }; })
        );
        choices.setChoices(newChoices, 'value', 'label', true);
      } else {
        $bodyTypeSelect.find('option').remove();
        $bodyTypeSelect.append('<option value=""></option>');
        $.each(data, function (index, value) {
          $bodyTypeSelect.append('<option value="' + value + '">' + value + '</option>');
        });
      }
      if (callback) {
        callback();
      }
    });
  }

  // Set a <select>'s value in a way that also updates a Choices.js widget when one
  // is attached (the legacy inventory form enhances these selects with Choices).
  // A bare jQuery .val() updates only the hidden native select, so the field looked
  // blank and then saved blank when Choices re-synced its empty selection on submit.
  function set_select_value($select, value) {
    if (value == null || value === '') return;
    var el = $select.get(0);
    if (el && el._choices) {
      el._choices.setChoiceByValue(String(value));
    } else {
      $select.val(value).removeClass('inactive');
    }
  }

  function vin_load_notice(message, delay){
    $(".load_notice").html(message).show().delay(delay).fadeOut(2000);
  }

  function toggle_print_forms_button() {
    if ($(".printable_form:checked").length > 0) {
      $("#print_form_button").removeAttr("disabled");
      $("#email_form_button").removeAttr("disabled");
    } else {
      $("#print_form_button").attr("disabled", "disabled");
      $("#email_form_button").attr("disabled", "disabled");
    }
  }

  // Coerce a jQuery .asNumber() result to a real, finite number. A garbage cost field (empty, "NaN",
  // non-numeric junk) makes asNumber() return NaN; a single one poisoned the running total so the
  // "Total cost" card rendered the literal "NaN" instead of a dollar value. Treat anything non-finite
  // as 0 — mirrors deal.js formatDealMoney's NaN guard. Every valid field is left exactly as-is, so a
  // real cost still totals identically.
  function safe_number(n){
    return (typeof n === 'number' && isFinite(n)) ? n : 0;
  }

  function calculate_additional_inventory_costs(){
    total = 0;
    setup_inventory_costs_fields();
    $.each($(".inventory_cost input[title=Amount]"), function(index, value){
      total += safe_number($(this).asNumber());
    });

    if ($("#floorplan_cost").length > 0) {
      total += safe_number($("#floorplan_cost").asNumber())
    }

    $("#cost").attr('value', total).formatCurrency();
  }

  function setup_inventory_costs_fields(){
    $(".inventory_cost input").change(function(){
      calculate_additional_inventory_costs();
    });

    $("form:has(input[title=Amount])").bind("submit", function(event){
      $(this).find("input[title=Amount]").each(function(){
        $(this).toNumber();
      });
    });
  }
  // helper function to generate slugs
  function to_slug(text){
    return text.replace(/\s+/g,'-').replace(/[^a-zA-Z0-9\-]/g,'').toLowerCase();
  }

  // ===== Entering a full field should let you replace it =====
  // PostHog: #inventory_vin is rage-clicked by 18 people, and at 8.5x its own page's baseline on
  // the EDIT form versus 4.6x the same field when empty. Cause: the input carries maxlength=17
  // (Ui::InputComponent splats html_options straight onto the <input>) and 97% of stored VINs are
  // exactly 17 characters — so on an existing vehicle the field is FULL. A click places a caret and
  // the browser then discards every keystroke until something is deleted or selected. Click, type,
  // nothing. Click, type, nothing.
  //
  // Same treatment as the desk money fields: entering the field selects what is in it, so the next
  // keystroke replaces it. Selection only — no value is read or written, so VIN decode and
  // validation behave exactly as before.
  //
  // ★ Scoped to the VIN input by NAME/ID, deliberately not to `.vin_lookup_field` or `.vin`: those
  // classes are also on Craigslist and eBay title/price/location fields, where select-on-entry
  // would fight anyone appending to a listing title.
  //
  // ★★ The money side is scoped to the FORM, not a hand-picked list of ids — because the
  // hand-picked list is exactly how this went wrong. It named `#inventory_price` and left out
  // `#inventory_wholesale_price`, which then turned out to be the single worst-behaved field on
  // the inventory pages: 66 clicks for 8 changes (8.25 clicks per edit, against ~1.4 for a normal
  // field) and 9 rage-clicks, measured 2026-09-10. down_payment and the three payment fields carry
  // `.currency_decimal` too and were missed the same way. Scoping by family covers the ones that
  // exist now AND the next money field somebody adds.
  //
  // ★ `#inventory_form` is the boundary that keeps this OFF the deal DESK. `.currency_decimal` is
  // also used throughout app/views/deals/**, and the desk form is `#desk-form`, so nothing here
  // reaches it — deliberate, because any deals change owes a full live regression
  // ([[deals-full-regression-rule]]) and the /deals/:id/edit money fields are not worth that on
  // their own.
  //
  // ★ 2026-10-21: the BHPH add-payment form (`form.new_payment`, payments/_form_v2) IS covered.
  // PostHog's weekly sweep had `payment_amount_paid` on /deals/:id/payments GROWING 3 -> 8
  // rage-clicks/week — the same formatted-number trap, on the page a BHPH dealer uses every day.
  // It was left out in September purely to avoid the regression cost; the live deals regression
  // harness now runs after every deals deploy, so the family covers it (scoped by form, not id).
  //
  // ★ 2026-10-21 (#74): the v2 deal EDIT form (/deals/:id/edit, deals/_form_v2) too. The sweep had
  // deal_cash_price there growing 5 -> 21 rage-clicks/week plus deal_state_tax_rate 13,
  // deal_license_fee 7, deal_interest_rate 3, deal_city_tax_rate 3 — every one a short numeric
  // `.calculate` input. Scoped by the form's data-controller (deal-fee-guard), which the desk's
  // #desk-form and the show page's forms-panel `form.edit_deal` do NOT carry, so the desk stays
  // out exactly as before.
  var SELECT_ON_ENTRY = [
    '#inventory_vin',
    'input[name="inventory[vin]"]',
    '#inventory_form input.currency_decimal',
    'form.new_payment input.currency_decimal',
    'form[data-controller~="deal-fee-guard"] input.calculate',
    'input[id^="inventory_inventory_costs_attributes_"][id$="_amount"]'
  ].join(', ');

  $(document).on('focusin', SELECT_ON_ENTRY, function () {
    var el = this;
    if (!$(el).val()) { return; }
    // The browser sets its own caret on mouseup, AFTER focus: defer past it, and swallow that one
    // mouseup so a plain click doesn't immediately collapse the selection.
    $(el).one('mouseup', function (ev) { ev.preventDefault(); });
    setTimeout(function () {
      if (document.activeElement !== el) { return; }
      try { el.select(); } catch (e) {}
    }, 0);
  });

  function activate_currency_fields(sel){
    $(".currency_decimal").formatCurrency();
    $(".currency_decimal").blur(function(){
      $(this).formatCurrency();
    });
    $(".currency, .currency_decimal").focus(function(){
      $(this).removeClass('inactive');
      $(this).toNumber();
    });
  }

  function get_authenticity_token(){
    return ($('input[name="authenticity_token"]').first().val() || $('meta[name="csrf-token"]').attr('content'));
  }

  function get_url_param_by_name(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  function setup_tablesorter() {
    if (!$.fn.tablesorter) return;
    return $('table.tablesorter').tablesorter({
      theme: 'bootstrap',
      widthFixed: true,
      headerTemplate: '{content} {icon}',
      widgets: ['uitheme', 'filter', 'zebra'],
      widgetOptions: {
        zebra: ['even', 'odd']
      }
    });
  }

  function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  };

  function random_id() {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
  }
})
document.addEventListener('turbo:load', () => {
  const el = document.getElementById("inventory_mileage");
  const form = el?.closest("form");

  if (!el || !form) return;

  // Mileage cleanup. This used to fight the dealer on every keystroke: an empty field was
  // instantly rewritten to "0", so backspacing to retype was impossible, and el.value was
  // reassigned on EVERY input, which throws the caret to the end and makes typing mid-number
  // hopeless. It also ran on load, so /inventory/new opened with a "0" sitting where the
  // "Add the mileage" placeholder should be. 5 people rage-clicked this field.
  //
  // Now: strip what cannot be a mileage, leave the field alone while it is empty, and only touch
  // el.value when the cleaned text actually differs — preserving the caret when it does. The
  // empty → "0" safety stays where it belongs, on submit, so nothing downstream changes.
  function clean(text) {
    var digits = String(text == null ? "" : text).replace(/[^\d]/g, "");
    if (digits === "") { return ""; }
    return String(parseInt(digits, 10));   // 0787 -> 787
  }

  function format() {
    var before = el.value;
    var after = clean(before);
    if (after === before) { return; }      // nothing to do: never disturb the caret for free

    // Restore the caret by counting digits to its left, so a correction mid-number stays put.
    var pos = (typeof el.selectionStart === "number") ? el.selectionStart : null;
    var digitsLeft = pos === null ? null : before.slice(0, pos).replace(/[^\d]/g, "").length;
    el.value = after;
    if (digitsLeft !== null) {
      var i = 0, seen = 0;
      while (i < after.length && seen < digitsLeft) { i++; seen++; }
      try { el.setSelectionRange(i, i); } catch (e) {}
    }
  }

  el.addEventListener("input", function () {
    format();
  });

  // On load, tidy an existing value but never manufacture one — an empty field must show its
  // placeholder, not a 0 the dealer then has to delete.
  if (el.value.trim() !== "") { format(); }

  // IMPORTANT: final safety before submit
  form.addEventListener("submit", function () {
    if (el.value.trim() === "") {
      el.value = "0";
    }
  });
});

// "Copy VIN" (inventory/v2/_tab_details). Copies what is in the field, exactly — trimmed, nothing
// else — and says so. navigator.clipboard needs a secure context; the select+execCommand fallback
// covers the rest. The button label is the only feedback, so it always changes.
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-copy-vin]');
  if (!btn) return;
  e.preventDefault();

  const field = document.querySelector(btn.dataset.copyVin);
  const vin = field ? field.value.trim() : '';
  const original = btn.dataset.label || (btn.dataset.label = btn.textContent);
  const say = (text) => {
    btn.textContent = text;
    clearTimeout(btn._copyTimer);
    btn._copyTimer = setTimeout(() => { btn.textContent = original; }, 1600);
  };
  if (!vin) { say('No VIN yet'); return; }

  const fallback = () => {
    try {
      const t = document.createElement('textarea');
      t.value = vin; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(t);
      say(ok ? 'Copied' : 'Copy failed');
    } catch (err) { say('Copy failed'); }
  };
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(vin).then(() => say('Copied'), fallback);
  } else {
    fallback();
  }
});

// The "Add new vendor" panel sits in one of two places relative to its `.control-group.vendor`:
//   - INSIDE it   — inventory_costs/_inv_cost_form
//   - right AFTER it, as a sibling — shared/_vendor (every deal vendor field: lienholder, insurer,
//     GAP, service contract, sale) and settings/inventory/_inventory_cost_vendor
// ★ Looking only inside is what killed "Add new vendor" on /deals/new and /deals/:id/edit from
// 2026-09-10 to 09-21: the click found no panel and returned silently. Chad at Autowerks (#123)
// phoned in unable to add a bank as a lienholder. Stop at the next vendor field so one link can
// never open a neighbouring field's panel.
function vendorPanelFor(wrapper) {
  const inside = wrapper.querySelector('.inner-form-vendor');
  if (inside) return inside;

  for (let el = wrapper.nextElementSibling; el; el = el.nextElementSibling) {
    if (el.matches('.inner-form-vendor')) return el;
    if (el.matches('.control-group.vendor')) return null;
  }
  return null;
}

document.addEventListener('turbo:load', () => {

  document.addEventListener('click', function (e) {
    const link = e.target.closest('.add-vendor');
    if (!link) return;

    e.preventDefault();

    const wrapper = link.closest('.control-group.vendor');
    if (!wrapper) return;

    const form = vendorPanelFor(wrapper);
    if (!form) return;

    const isHidden = window.getComputedStyle(form).display === 'none';

    if (isHidden) {
      form.style.display = 'block';
      link.textContent = 'Remove new vendor';
      link.style.color = 'red';
      link.style.setProperty('font-size', '0.85rem', 'important');

      // Belt-and-suspenders for the hidden-init dropdown bug class (same as the
      // lienholder default dropping on save): the vendor State <select> is a
      // Choices-backed select initialised while this panel was display:none and
      // server-rendered with the account's default state (build_vendor(state:)).
      // The central choices_controller already force-syncs the native value at
      // init, so this is normally already correct — re-assert the selection on
      // reveal through the Choices instance so the default state can never save
      // blank if a dealer opens the panel and submits without touching State.
      var stateSelect = form.querySelector('select.state');
      if (stateSelect && stateSelect._choices) {
        var currentState = stateSelect.value || stateSelect.getAttribute('data-account-state');
        if (currentState) stateSelect._choices.setChoiceByValue(currentState);
      }
    } else {
      form.style.display = 'none';
      link.textContent = 'Add new vendor';
      link.style.color = '#5e72e4';
      link.style.setProperty('font-size', '0.85rem', 'important');
    }
  });

});
document.addEventListener('turbo:load', () => {
  // Prevent duplicate bindings (VERY important with Turbo)
  $('#autodesc-block').hide();
  $(document).off('click', '#autodesc-toggle');
  $(document).off('click', '.autodesc-list li');
  $(document).off('click', '#autodesc-group-items li');
  $(document).off('click', '#autodesc-block #newpara');
  $(document).off('click', '#autodesc-block #cleartinymce');

  // Toggle AutoDesc block
  $(document).on('click', '#autodesc-toggle', function(e) {
    e.preventDefault();
    $('#autodesc-block').slideToggle();
  });

  // Select description group
  $(document).on('click', '.autodesc-list li', function() {
    $('.autodesc-list li').removeClass('selected');
    $(this).addClass('selected');

    var index = $(this).parent().find("li").index(this);

    $('#autodesc-group-items ul').removeClass('selected');
    $('#autodesc-group-items ul').eq(index).addClass('selected');
  });

  // Insert content into TinyMCE
  $(document).on('click', '#autodesc-group-items li', function() {
    var editor = tinymce.get('inventory_description');
    if (editor) {
      editor.execCommand('mceInsertContent', false, " " + $(this).html());
    }
  });

  // Add new paragraph
  $(document).on('click', '#autodesc-block #newpara', function() {
    var editor = tinymce.get('inventory_description');
    if (editor) {
      editor.execCommand('mceInsertContent', false, " <br/><br/><br/>");
    }
  });

  // Clear TinyMCE content
  $(document).on('click', '#autodesc-block #cleartinymce', function() {
    var editor = tinymce.get('inventory_description');
    if (editor) {
      editor.setContent('');
    }
  });
});
function bindPriceHistoryHover() {
  $(document).on('mouseenter', '.history-edit', function () {
    var $wrapper = $(this);
    var vehicleId = $wrapper.data('vehicle-id');
    var $historyBox = $wrapper.find('.price-history');

    $historyBox
      .addClass('arrow_box')
      .show()
      .html('Loading...');

    $.ajax({
      url: '/inventory/' + vehicleId + '/price_history',
      success: function (data) {
        $historyBox.html(data);
      },
      error: function () {
        $historyBox.html('Error loading');
      }
    });
  });

  $(document).on('mouseleave', '.history-edit', function () {
    $(this).find('.price-history').hide();
  });

  // Live-recalc the vehicle Gross Profit as the price is typed.
  // Mirrors Inventory#gross_profit_at_sale_today = price - today_flooring_with_cost;
  // the .gross-profit span carries data-cost (today_flooring_with_cost).
  // Trigger on the price field in BOTH markups: v2 (#inventory_price, not wrapped in .price-row)
  // and legacy (.price-row .currency_decimal). Wholesale price is excluded (it's outside .price-row
  // and isn't #inventory_price), so it never mis-fires this.
  $(document).on('input', '#inventory_price, .price-row .currency_decimal', function () {
    var $gp = $('.gross-profit');
    if (!$gp.length) return;
    var cost = parseFloat(($gp.data('cost') + '').replace(/[^0-9.\-]/g, '')) || 0;
    // Read the price explicitly from #inventory_price (v2); fall back to the triggering field (legacy).
    var $price = $('#inventory_price');
    var priceVal = $price.length ? $price.val() : $(this).val();
    var price = parseFloat((priceVal + '').replace(/[^0-9.\-]/g, '')) || 0;
    var profit = price - cost;
    var formatted = (profit < 0 ? '-$' : '$') +
      Math.abs(profit).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    // The value span differs by markup: legacy uses `.strong`, v2 uses `.font-semibold`.
    var $val = $gp.find('.strong');
    if (!$val.length) $val = $gp.find('.font-semibold');
    if (!$val.length) $val = $gp.find('span').last();
    $val.text(formatted);
    // Apply BOTH color-class conventions (legacy dark_green/red + v2 text-success/text-danger);
    // the irrelevant pair is simply inert in each markup.
    $val.removeClass('dark_green red text-success text-danger')
      .addClass(profit > 0 ? 'dark_green text-success' : 'red text-danger');
  });
}

// initial load
$(document).on('turbo:load', function () {
  bindPriceHistoryHover();
});
function cleanup_operations(formulaDiv) {
  var outputDivs = formulaDiv.find(".output li");

  // Remove any stray operation symbols at the start or end
  if (outputDivs.first().hasClass("operation")) {
      outputDivs.first().remove();
  } else if (outputDivs.last().hasClass("operation")) {
      outputDivs.last().remove();
  }

  var last = null;
  $.each(outputDivs, function(i, v) {
      var j = $(v);
      if (last && last.hasClass("operation") && j.hasClass("operation")) {
          last.remove();
      }
      last = j;
  });
}
function formulaOperation(type) {
  // Type should be either '+' or '-'
  return "<li class='operation label' data-formula='(" + type + ")'>" + type + "</li>";
}

function formulaPiece(field, typed) {
  var value, text;
  if (field) {
      value = field.attr("value");
      text = field.text();
  } else {
      value = typed;
      text = typed;
  }
  return "<li class='piece label' data-formula='" + value + "'>" + text + " <i class='fa fa-remove delete-piece'></i></li>";
}

function update_formula_output(formulaDiv) {
  cleanup_operations(formulaDiv);
  var input = $(formulaDiv).find(".formula_value");
  var pieces = update_formula_value(formulaDiv);
  input.val(pieces.join(""));
}

function update_formula_value(formulaDiv) {
  var pieces = [];
  $(formulaDiv).find(".output li").each(function(i, v) {
      pieces.push($(v).attr("data-formula"));
  });
  return pieces;
}
document.addEventListener("turbo:load", function () {
  $(document).ready(function() {
    // Attach event handler for dynamically added "Add" buttons inside the formula class
    $("#fields.form_field").on("click", ".formula button", function(e) {
      e.preventDefault();
      var formulaDiv = $(this).closest(".formula");
      var value = formulaDiv.find("select.formula_picker").val();
      var selected, typed = null;

      if (value) {
        var select = $(this).siblings("select.formula_picker");
        selected = select.find("option[value='" + value + "']");

        // Check if the value has already been added to prevent duplicates
        var alreadyAdded = formulaDiv.find(".output ul li[data-formula='" + value + "']").length > 0;
        if (alreadyAdded) {
            return; // Stop execution if the formula is already added
        }

        // Handle value either as a selected option or as a typed custom input
        if (selected.length === 0) {
            selected = null;
            typed = value; // Set typed to the value from the select
        } else {
            typed = null; // Reset typed as we have a selected option
        }

        var outputList = formulaDiv.find(".output ul");
        var outputItems = outputList.find("li");

        // Add a "+" operation if there are already formula pieces
        if (outputItems.length >= 1) {
            outputList.append(formulaOperation("+"));
        }
        outputList.append(formulaPiece(selected, typed));

        // Update the formula output value
        update_formula_output(formulaDiv);
      }
    });
  });
  $(document).on('click', '.form_field .formula button', function(e) {
    e.preventDefault();

    var formulaDiv = $(this).closest(".formula");
    var value = formulaDiv.find("select.formula_picker").val();
    var selected, typed = null;

    if (value) {
      var select = $(this).siblings("select.formula_picker");
      selected = select.find("option[value='" + value + "']");

      var alreadyAdded = formulaDiv.find(".output ul li[data-formula='" + value + "']").length > 0;
      if (alreadyAdded) {
        return;
      }

      if (selected.length === 0) {
        selected = null;
        typed = value;
      } else {
        typed = null;
      }

      var outputList = formulaDiv.find(".output ul");
      var outputItems = outputList.find("li");

      if (outputItems.length >= 1) {
        outputList.append(formulaOperation("+"));
      }
      outputList.append(formulaPiece(selected, typed));

      update_formula_output(formulaDiv);
    }
  });

  $(".formula .output").on("click", ".delete-piece", function(e) {
    e.preventDefault();
    var formulaDiv = $(this).closest(".formula");
    $(this).closest("li").remove();
    update_formula_output(formulaDiv);
  });
})
document.addEventListener("turbo:load", function () {
  $(document).ready(function() {
    $("#layout .form_field[id!=form_image]").draggable({
      grid: [1, 1],
      snap: ".draggable-y, .draggable-x",
      snapTolerance: 5,
      containment: "#layout",
      zIndex: 5000,
      cursor: "pointer",
      scroll: true,
      stop: function(event, ui) {
        var element = $(event.target);
        var id = element.attr("id").replace("form_field_", "");
        var jElement = $(element);
        $("#field_print_x_" + id).attr("value", jElement.css("left"));
        $("#field_print_y_" + id).attr("value", jElement.css("top"));
      }
    });

    $(".print-widths").val(function() {
      return $(this).nextAll(".ui-draggable").first().width();
    });

    $("#fields").on("click", ".formula button", function(e) {
      e.preventDefault();
      var formulaDiv = $(this).parents(".formula");
      var value = $(this).siblings(".combobox-container").find("[name='formula_picker']").val();
      
      if (value) {
        var select = $(this).siblings("select.formula_picker");
        var selected = select.find("option[value='" + value + "']");
        
        if (selected.length > 0) {
          var typed = null;
        } else {
          var typed = value;
          select.find("option").each(function() {
            var optionText = $(this).text().replace(/\s/g, "").toLowerCase();
            var valueText = value.replace(/\s/g, "").toLowerCase();
            if (valueText === optionText) {
              selected = $(this);
              typed = null; // If a match is found, set typed to null
              return false; // Break the loop
            }
          });
        }

        $(this).siblings(".combobox-container").find(".combobox-clear").click();

        var outputList = formulaDiv.find(".output ul");
        var outputItems = outputList.find("li");

        if (outputItems.length >= 1) {
          outputList.append(formula_operation("+"));
        }
        outputList.append(formula_piece(selected, typed));

        update_formula_output(formulaDiv);
      }
    });
  });
})
onDomReady(function() {
  const dropdown = document.getElementById('account-dropdown');
  // Only present on some pages — bail out elsewhere (this was throwing on every page).
  if (!dropdown) return;

  // Add event listener for dropdown changes
  dropdown.addEventListener('change', function() {
    const selectedValue = this.value;
    
    // Redirect if the value is not "other"
    if (selectedValue && selectedValue !== "other") {
      window.location.href = selectedValue;
    }
  });
});

$('#billing-dropdown').change(function() {
  var selectedValue = $(this).val();
  if (selectedValue) {
    window.location.href = selectedValue;
  }
});
$('#craigslist-dropdown').change(function() {
  var selectedValue = $(this).val();
  if (selectedValue) {
    window.location.href = selectedValue;
  }
});
$(document).on("scroll", function () {
  const sidebar = $("#sidenav-main");
  const scrollPosition = $(window).scrollTop();

  if (scrollPosition > 30) {
      sidebar.css("top", "0px");
  } else {
      sidebar.css("top", "125px");
  }
});
function makeGuide(el, axis, container) {
  const $el = $(el);

  if ($el.hasClass("ui-draggable")) return;

  const axisClass = axis === "x" ? "x-guide" : "y-guide";

  $el.draggable({
    axis: axis,
    containment: container,
    drag: function () {
      const pos = $(this).position();
      const value = axis === "x" ? pos.left : pos.top;
      $(this).find(".pos").text(`${axis.toUpperCase()}: ${value}px`);
    },
    start: function () {
      $(this).find(".pos").show();
    },
    stop: function () {
      const pos = $(this).position();
      const value = axis === "x" ? pos.left : pos.top;
      $(this).find(".pos").hide();
      $(this).data("value", value);
    }
  });
}
$(document).on("dblclick", "#layout", function (e) {
  const offset = $(this).offset();

  const x = e.pageX - offset.left;
  const y = e.pageY - offset.top;

  const axis = e.shiftKey ? "y" : "x";

  if (axis === "x") {
    spawnGuide("x");
    $(".draggable-x").last().css("left", x);
  } else {
    spawnGuide("y");
    $(".draggable-y").last().css("top", y);
  }
});
function spawnGuide(axis) {
  const id = Date.now();
  const cls = axis === "x" ? "draggable-x" : "draggable-y";

  const $guide = $(`
    <div class="draggable-handle ${cls}">
      <span class="pos"></span>
      <input type="hidden" name="guidelines[${axis}_axis][]" value="">
    </div>
  `);

  $("#layout").append($guide);

  makeGuide($guide[0], axis, "#layout");
}
function initLayoutRulers() {
  if (!$("#layout").length) return;

  $("#layout .draggable-handle").each(function () {
    const axis = $(this).hasClass("draggable-x") ? "x" : "y";
    makeGuide(this, axis, "#layout");
  });

  // ALSO initialize templates if present
  $(".draggable-x-newest, .draggable-y-newest").each(function () {
    const axis = $(this).hasClass("draggable-x") ? "x" : "y";
    makeGuide(this, axis, "#layout");
  });
}
document.addEventListener("turbo:load", () => {
  initLayoutRulers();
});
$(document).on('click', '.date-input', function() {
  console.log('hi');
  $('.date-input').off('input').on('input', function () {
    const $dateField = $(this);
    const $errorMessage = $dateField.next('.date-error');

    let value = $dateField.val().replace(/\D/g, '');

    if (value.length > 2) {
        value = value.slice(0, 2) + '/' + value.slice(2);
    }
    if (value.length > 5) {
        value = value.slice(0, 5) + '/' + value.slice(5, 9);
    }
    $dateField.val(value);

    // Validate input as the user types
    validateAndUpdate(value, $dateField, $errorMessage);
  });

  $('.date-input').on('blur', function () {
    const $dateField = $(this);
    const $errorMessage = $dateField.next('.date-error');
    const value = $dateField.val();

    // Validate input on blur (losing focus)
    validateAndUpdate(value, $dateField, $errorMessage);
  });

  function validateAndUpdate(value, $dateField, $errorMessage) {
    let isValid = true;
    let errorMessage = '';

    // Identify the field type
    const isDateOfBirth = $dateField.hasClass('date-of-birth');
    // Past dates are allowed by default for data-entry fields (cost/expense dates
    // are almost always historical). Only fields that genuinely need a future
    // date (expiration, etc.) opt into the restriction via `.no-past-date`, and
    // an explicit `.allow-past-date` always permits past (cost dates use this).
    const isPastDateNotAllowed = $dateField.hasClass('no-past-date') &&
                                 !$dateField.hasClass('allow-past-date');

    // Validate empty value
    if (value.length === 0) {
        isValid = false;
        errorMessage = 'Please enter a valid date in mm/dd/yyyy format.';
    }

    // Validate Month
    if (isValid && value.length >= 2) {
        const month = parseInt(value.slice(0, 2), 10);
        if (isNaN(month) || month < 1 || month > 12) {
            isValid = false;
            errorMessage = 'Invalid month. Please enter a valid month (01-12).';
        }
    }

    // Validate Incomplete Date (only after month validation)
    if (isValid && value.length < 10) {
        isValid = false;
        errorMessage = 'Incomplete date. Please enter a valid date in mm/dd/yyyy format.';
    }

    // Validate Day
    if (isValid && value.length >= 5) {
        const month = parseInt(value.slice(0, 2), 10);
        const day = parseInt(value.slice(3, 5), 10);
        if (isNaN(day) || day < 1 || day > 31) {
            isValid = false;
            errorMessage = 'Invalid day. Please enter a valid day.';
        } else {
            const daysInMonth = [
                31, (isLeapYear(new Date().getFullYear()) ? 29 : 28),
                31, 30, 31, 30, 31, 31, 30, 31, 30, 31
            ];
            if (day > daysInMonth[month - 1]) {
                isValid = false;
                errorMessage = 'Invalid day for the selected month.';
            }
        }
    }

    // Validate Year and Complete Date
    if (isValid && value.length === 10) {
        const [month, day, year] = value.split('/').map(Number);
        if (!validateDate(month, day, year)) {
            isValid = false;
            errorMessage = 'Invalid date. Please enter a valid date in mm/dd/yyyy format.';
        }

        // Custom validation for Date of Birth (not in the future)
        if (isDateOfBirth && isValid) {
            const inputDate = new Date(year, month - 1, day);
            const today = new Date();
            if (inputDate > today) {
                isValid = false;
                errorMessage = 'Date of birth cannot be in the future.';
            }
        }

        // Custom validation for future dates (payment, expiration, etc.)
        if (isPastDateNotAllowed && isValid) {
            // Compare at day granularity in the user's local timezone so that
            // TODAY is always allowed. Using `new Date()` directly would include
            // the current time-of-day, making today-at-midnight appear "in the
            // past" for the rest of the day.
            const inputDate = new Date(year, month - 1, day);
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            if (inputDate < today) {
                isValid = false;
                errorMessage = 'This date cannot be in the past.';
            }
        }
    }

    // Update UI based on validation result
    if (!isValid) {
        $errorMessage.text(errorMessage);
        $dateField.addClass('is-invalid');
    } else {
        $errorMessage.text('');
        $dateField.removeClass('is-invalid');
    }
  }

  function validateDate(month, day, year) {
    if (month < 1 || month > 12 || day < 1 || day > 31) return false;

    const daysInMonth = [31, (isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (day > daysInMonth[month - 1]) return false;

    return true;
  }

  function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }
});
$(document).on('click', '#photo-overlay', function (event) {
  event.preventDefault();

  const redirectUrl = '/inventory/photo_overlay';

  window.location.href = redirectUrl;
});

(function() {
  const initialHeight = 473;
  let marginObserver = null;

  function updateMargin() {
    const currentHeight = $('.inv-images-section').outerHeight();
    if (currentHeight > initialHeight) {
      const marginTop = -(currentHeight - initialHeight);
      $('#photo-overlay-section').css('margin-top', marginTop + 'px');
    } else {
      $('#photo-overlay-section').css('margin-top', '0px');
    }
  }

  function checkScreenSize() {
    return window.innerWidth >= 992;
  }

  function disconnectMarginObserver() {
    if (marginObserver) {
      marginObserver.disconnect();
      marginObserver = null;
    }
  }

  function applyMarginLogic(retryCount = 0) {
    disconnectMarginObserver();

    // The v2 photos page (.v2-legacy-embed) is a single-column flow layout. The negative
    // margin-top hack below was built for the OLD 2-column grid; on v2 it drags
    // #photo-overlay-section UP on top of the Delete-all / Sorting sections (overlap).
    // On v2 let everything flow naturally (margin-top:0) and skip the observer.
    if (document.querySelector('.v2-legacy-embed #photo-overlay-section, .v2-legacy-embed #inventory-gallery-app')) {
      $('#photo-overlay-section').css('margin-top', '0px');
      return;
    }

    if (!checkScreenSize()) {
      $('#photo-overlay-section').css('margin-top', '0px');
      return;
    }

    const target = document.querySelector('.inv-images-section');
    if (!target) {
      if (retryCount < 20 && document.getElementById('inventory-gallery-app')) {
        setTimeout(function() {
          applyMarginLogic(retryCount + 1);
        }, 100);
      }
      return;
    }

    updateMargin();

    marginObserver = new MutationObserver(function() {
      updateMargin();
    });

    marginObserver.observe(target, { attributes: true, childList: true, subtree: true });
  }

  document.addEventListener('turbo:load', function() {
    applyMarginLogic();
  });

  $(window).on('resize', function() {
    applyMarginLogic();
  });
})();


// ===== EPA MPG lookup =====
// VINquery leaves fuel_economy_city/highway blank on about half of everything dealers add, and
// they have been filling it in by hand from fueleconomy.gov. This button does that lookup and
// drops the numbers into the two form fields. It deliberately does NOT save and does NOT
// overwrite a value already there — the dealer reads it, edits it if they disagree, and it only
// reaches their public listing when they press Save. See InventoryController#fuel_economy_lookup.
//
// ★DOMContentLoaded is unreliable here: this is an ESM module and vite may execute it after the
// document is already parsed, in which case the event has been and gone (see bin/lint-footguns).
// Run straight away when the DOM is ready and only wait on the event when it genuinely isn't.
function initMpgLookup() {
  var btn = document.getElementById('mpg-lookup-btn');
  if (!btn || btn.dataset.mpgBound === '1') return;
  btn.dataset.mpgBound = '1';

  var status = document.getElementById('mpg-lookup-status');
  var cityEl = document.getElementById('inventory_fuel_economy_city');
  var hwyEl = document.getElementById('inventory_fuel_economy_highway');
  if (!cityEl || !hwyEl) return;

  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }
  function say(msg, tone) {
    if (!status) return;
    status.textContent = msg;
    status.className = 'text-sm ' + (tone === 'bad'
      ? 'text-amber-600 dark:text-amber-400'
      : 'text-slate-500 dark:text-slate-400');
  }

  btn.addEventListener('click', function () {
    var year = val('inventory_year'), make = val('inventory_make'), model = val('inventory_model');
    if (!year || !make || !model) {
      say('Fill in the year, make and model first.', 'bad');
      return;
    }

    var params = new URLSearchParams({
      year: year, make: make, model: model,
      trim: val('inventory_trim_level'),
      engine: val('inventory_engine'),
      fuel_type: val('inventory_fuel_type')
    });

    btn.disabled = true;
    say('Checking the EPA database…');

    fetch(btn.dataset.url + '?' + params.toString(), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        // A non-2xx here still returns JSON from the controller; anything else is a real failure
        // and must not be parsed as a result, or "found: undefined" reads as "no match".
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || !data.found) {
          say((data && data.message) || 'No EPA rating found for this vehicle.', 'bad');
          return;
        }
        cityEl.value = data.city;
        hwyEl.value = data.highway;
        [cityEl, hwyEl].forEach(function (el) {
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        });
        say(data.source + ' — check it, then Save to keep it.');
      })
      .catch(function () {
        say('Could not reach the EPA database. Try again, or enter the MPG by hand.', 'bad');
      })
      .finally(function () { btn.disabled = false; });
  });
}

onDomReady(initMpgLookup);
